<template>
  <div class="w-full h-full px-5 pt-5">
    <div class="flex flex-col gap-6">
      <div class="flex justify-start items-center gap-8">
        <h1 class="text-xl text-left font-extrabold">
          Documents
        </h1>
        <breadcrumb :items="breadcrumbs" />
      </div>

      <Tab
        :tabs="tabs"
        :border="true"
        :active-tab="currentTab"
        v-model="currentTab"
        @currentTab="handleCurrentTab($event)"
      />
      <div class="h-full">
        <Employees
          v-if="currentTab === 'Employees'"
        />

        <Documents
          v-if="currentTab === 'Documents'"
          :current-tab="currentTab"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@scelloo/cloudenly-ui/src/components/bread-crumb";
import Tab from "@scelloo/cloudenly-ui/src/components/tab";

  export default {
    name: "EmployeeDocs",
    components: {
      Breadcrumb,
      Tab,
      Employees: () => import("./employees/index"),
      Documents: () => import("./documents/index")
    },
    data() {
      return {
        currentTab: this.$route.query.currentTab || "Employees",
        tabs: ["Employees", "Documents"]
      };
    },
    computed: {
      breadcrumbs() {
        return [
          {
            disabled: false,
            text: "Documents",
            href: "OrganisationCompanyDocuments",
            id: "DocumentMgt",
          },
          {
            disabled: false,
            text: "Employee Documents",
            href: "EmployeeDocuments",
            id: "EmpDocuments",
          },
        ];
      }
    },
    methods: {
      handleCurrentTab(currentTab) {
        if (this.currentTab !== currentTab) {
          this.currentTab = currentTab;
          this.$router.push({ query: { currentTab } });
        }
      },
    }
  };
</script>

<style scoped>
</style>
